<template>
  <div>
    <SpinnerSheet ref="spinnerSheet" :loading="showSpinner"></SpinnerSheet>
    <StblView v-if="subItemId !== 'STBL-1014278'"
              :sub-item-id="subItemId"
              :stat-id="statId"
              :stats-parameters-id="statsParametersId"
              :item-idx="itemIdx"
              :infoItem="infoItem"
              @spinner-apply="spinnerApply">
    </StblView>
    <StblIndexView v-if="subItemId === 'STBL-1014278'"
                   :sub-item-id="subItemId"
                   :stat-id="statId"
                   :stats-parameters-id="statsParametersId"
                   :item-idx="itemIdx"
                   :infoItem="infoItem"
                   @spinner-apply="spinnerApply">
    </StblIndexView>
  </div>
</template>

<script>
import StblView from "@/components/StblView";
import StblIndexView from "@/components/StblIndexView";
import SpinnerSheet from "@/components/SpinnerSheet.vue";

export default {
  name: "StblSelector",
  components: {
    SpinnerSheet,
    StblView,
    StblIndexView
  },

  props: {
    subItemId: {
      type: String,
      default: ''
    },
    statId: {
      type: String,
      default: ''
    },
    itemIdx: {
      type: String,
      default: ''
    },
    statsParametersId: {
      type: String,
      default: ''
    },
    infoItem: {

    }
  },
  data() {
    return {
      showSpinner: false
    }
  },
  methods: {
    spinnerApply(isShow) {
      this.showSpinner = isShow;
      if (this.$refs.spinnerSheet) {
        this.$refs.spinnerSheet.showLoading(isShow);
      }
    }
  },
}
</script>

<style scoped>

</style>
